import { createFileRoute } from '@tanstack/react-router'
import { ResendVerificationPage } from '@/features/auth/pages/ResendVerificationPage'

export const Route = createFileRoute('/_auth/resend-verification')({
  component: ResendVerificationPage,
})
